import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useStore } from "store";
import ApiManager from "resources/ApiManager/api";

import {
  theme,
  Flex,
  Space,
  Layout,
  Typography,
  Button,
  Form,
  Input,
  Tooltip,
} from "antd";
const { Content } = Layout;
const { Title, Text } = Typography;

import {
  MailOutlined,
  LockOutlined,
  CheckCircleOutlined,
  SendOutlined,
} from "@ant-design/icons";
import CONSTANTS from "shared/constants";
import strings from "resources/strings";
import FooterContent from "components/Shared/FooterContent";
import FloatingCard from "../../../components/Shared/FloatingCard";

import "./style.scss";

const styleWrapperClass = "login";

import axios from "axios";

export default function Login() {
  const { token: theme_token } = theme.useToken();

  const navigate = useNavigate();

  const setUser = useStore((state) => state.setUser);
  const setActiveRfc = useStore((state) => state.setActiveRfc);

  const [form] = Form.useForm();
  const [isSubmitting, setSubmitting] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [emailValue, setEmailValue] = useState(null);

  const isInvalidEmail =
    !!!emailValue || emailValue.indexOf("@") < 0 || emailValue.indexOf(".") < 0;

  const updateEmailValue = (e) => {
    setEmailValue(e.target.value);
  };

  const onFinish = async (values) => {
    setSubmitting(true);
    setModalErrorTitle(null);

    const apiRes = await ApiManager.postUserLogin(
      "password",
      null,
      values.email,
      values.password
    );

    setSubmitting(false);

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      return;
    }

    if (apiRes.response.code === 3000 || apiRes.response.code === 3001) {
      // Could not authenticate user
      setModalErrorTitle(strings.loginIncorrectCredentials);
      return;
    } else if (apiRes.response.code !== 2000) {
      setModalErrorTitle(strings.alertUnexpectedError);
      return;
    }

    const { user } = apiRes.data;

    // setToken(token);
    setUser(user);
    setActiveRfc();
  };

  const sendMagicLink = async () => {
    console.log("magic link", emailValue);

    setSubmitting(true);
    setModalErrorTitle(null);

    let requestPath, requestData, responseApi, responseCode;

    //Get login token
    requestData = {
      type: "login",
      email: emailValue,
    };

    requestPath = "/user/email-token";
    responseApi = await axios
      .get(requestPath, { params: requestData })
      .catch((error) => {
        console.log(error);
        setSubmitting(false);
        setModalErrorTitle(strings.alertUnexpectedError);
      });

    setSubmitting(false);

    if (!responseApi) {
      return;
    }

    responseCode = responseApi.data.response.code;

    if (responseCode === 3000 || responseCode === 3001) {
      // Could not authenticate user
      setModalErrorTitle(strings.loginIncorrectCredentials);
      return;
    } else if (responseCode !== 2000) {
      setModalErrorTitle(strings.alertUnexpectedError);
      return;
    } else {
      setIsSubmitted(true);
      form.resetFields();
    }
  };

  const loginForm = (
    <Form form={form} onFinish={onFinish} style={{ maxWidth: "500px" }}>
      <FloatingCard title="Inicia Sesión">
        <Flex vertical gap={10}>
          <Space direction="vertical" size={0}>
            <Text>Ingresa utilizando tu correo electrónico y contraseña.</Text>
          </Space>

          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: strings.validationEmailRequired,
              },
            ]}
            style={{ marginBottom: "5px" }}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                prefix={
                  <MailOutlined style={{ color: theme_token.colorPrimary }} />
                }
                type="email"
                placeholder={strings.formEmail}
                onChange={updateEmailValue}
              />
              {/* <Tooltip title="Enviar liga de acceso">
                  <Button
                    icon={<SendOutlined />}
                    type="primary"
                    onClick={sendMagicLink}
                    disabled={isSubmitting || isInvalidEmail}
                  />
                </Tooltip> */}
            </Space.Compact>
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: strings.validationPasswordRequired,
              },
            ]}
            style={{ marginBottom: "0px" }}
          >
            <Input.Password
              prefix={
                <LockOutlined style={{ color: theme_token.colorPrimary }} />
              }
              type="password"
              placeholder={strings.formPassword}
            />
          </Form.Item>

          <Link to="/reset" style={{ fontWeight: "500" }}>
            ¿Olvidaste tu contraseña?
          </Link>

          {modalErrorTitle && (
            <Text style={{ color: theme_token.colorError, fontWeight: "600" }}>
              {modalErrorTitle}
            </Text>
          )}

          <Button
            size="medium"
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
            block
            style={{ marginTop: "15px" }}
          >
            Iniciar Sesión
          </Button>
        </Flex>

        <Flex align="center" vertical gap={10} style={{ marginTop: "20px" }}>
          <Text>¿No tienes cuenta? Crea una aquí:</Text>
          <Button
            type="primary"
            disabled={isSubmitting}
            block
            onClick={() => {
              return navigate("/registro");
            }}
          >
            Crear Cuenta
          </Button>
        </Flex>
      </FloatingCard>
    </Form>
  );

  const submittedView = (
    <FloatingCard>
      <Flex align="center" vertical gap={5}>
        <CheckCircleOutlined
          style={{ fontSize: "40px", color: theme_token.colorPrimary }}
        />
        <Title level={3} style={{ textAlign: "center" }}>
          ¡Se envió una liga de acceso a tu correo electrónico!
        </Title>
        <Title level={5} style={{ textAlign: "center" }}>
          Haz click en el botón del correo electrónico para iniciar sesión.
        </Title>
        <Button type="primary" onClick={() => setIsSubmitted(false)}>
          Regresar
        </Button>
      </Flex>
    </FloatingCard>
  );

  return (
    <div className={styleWrapperClass}>
      <Layout>
        <Content style={{ marginTop: "50px" }}>
          <Flex align="center" vertical gap={30}>
            <img
              src={strings.url_logo_colored_svg}
              alt={strings.appName}
              style={{
                width: "200px",
              }}
            />
            {isSubmitted ? submittedView : loginForm}
          </Flex>
        </Content>
        <FooterContent />
      </Layout>
    </div>
  );
}
